import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const ANIMATION_TIME = 500;

class Input extends Component {
  setupDefaults() {
    this.dom = {
      $menu: this.el._$('.mag-header__menu'),
      $openButton: this.el._$('.mag-header__trigger-button--open'),
      $closeButton: this.el._$('.mag-header__trigger-button--close')
    };

    this.focusTrap = createFocusTrap(this.dom.$menu);
  }

  addListeners() {
    const { $openButton, $closeButton } = this.dom;

    $openButton._on('click', ::this.handleOpen);
    $closeButton._on('click', ::this.handleClose);
  }

  handleOpen() {
    this.el.classList.add('mag-header--open');
    disableBodyScroll(this.el);
    setTimeout(() => this.focusTrap.activate(), ANIMATION_TIME);
  }

  handleClose() {
    this.el.classList.remove('mag-header--open');
    clearAllBodyScrollLocks();
    this.focusTrap.deactivate();
  }
}

export default Input;
